import { VatState } from './vat-reducer';
import { VAT_ACTION_TYPE, VatActions } from './vat-type';

export const vatCreators = {
  setVatState: <KeyName extends keyof VatState>(key: KeyName, value: VatState[KeyName])
    : VatActions => ({
      type: VAT_ACTION_TYPE.SET_VAT_STATE,
      payload: { key, value }
    }),
  callVatAdd: () => ({
    type: VAT_ACTION_TYPE.CALL_VATADD
  }),
};
